import React, { useState } from "react"
import { useMutation, useQuery } from "react-apollo"
import { CheckboxFieldBlock } from "gatsby-interface"

import { usePrevious } from "@modules/toolkit/hooks/usePrevious"
import { useTracker } from "@modules/analytics"
import capitalizeStr from "@modules/toolkit/helpers/capitalizeStr"
import {
  AVAILABLE_PLUGINS_QUERY,
  ATTACH_PLUGIN_MUTATION,
  REMOVE_PLUGIN_MUTATION,
  updatePluginSetup,
} from "./PublishReports.helpers"
import { useGenericError } from "../../../modal"

function PublishReports({ siteId, buildsEnabled }) {
  const { data } = useQuery(AVAILABLE_PLUGINS_QUERY, {
    variables: {
      siteId,
    },
  })

  const availablePlugins = (data && data.availableReportPlugins) || []
  const [attachPluginMutate] = useMutation(ATTACH_PLUGIN_MUTATION)
  const [removePluginMutate] = useMutation(REMOVE_PLUGIN_MUTATION)
  const prevBuildsEnabled = usePrevious(buildsEnabled)
  const { trackButtonClicked } = useTracker()
  const throwError = useGenericError()
  const [isSubmitting, setIsSubmitting] = useState({})

  React.useEffect(() => {
    if (buildsEnabled !== prevBuildsEnabled && !buildsEnabled) {
      updatePluginSetup({
        siteId,
        removePluginMutate,
        throwError,
        isSubmitting,
        setIsSubmitting,
        trackButtonClicked,
        availablePlugins,
      })
    }
  }, [buildsEnabled])

  return availablePlugins.map(({ id, name, vendor, enabled }) => (
    <CheckboxFieldBlock
      key={id}
      id="pluginEnabled"
      label={`${capitalizeStr({
        str: name,
      })} report enabled`}
      disabled={!buildsEnabled}
      onChange={() =>
        updatePluginSetup({
          siteId,
          id,
          enabled,
          vendor,
          availablePlugins,
          attachPluginMutate,
          removePluginMutate,
          throwError,
          isSubmitting,
          setIsSubmitting,
          trackButtonClicked,
        })
      }
      checked={enabled}
    />
  ))
}

export default PublishReports
